export const ShareMockData = [
	{
		id: 1,
		value: "Copy Link",
		path: "http://arcadia.pinnacle.com:3001/en/account",
		active: false,
	},
	{
		id: 2,
		value: "Facebook",
		path: "http://arcadia.pinnacle.com:3001/en/account/bets",
		active: false,
	},
	{
		id: 3,
		value: "Twitter",
		path: "http://arcadia.pinnacle.com:3001/en/account/preferences",
		active: false,
	},
	{
		id: 4,
		value: "Reddit",
		path: "http://arcadia.pinnacle.com:3001/en/account/deposit",
		active: false,
	},
	{
		id: 5,
		value: "Linkedin",
		path: "http://arcadia.pinnacle.com:3001/en/account/deposit",
		active: false,
	},
];
